<template>
  <aside tabindex="0" class="zb-modal" :class="{ active: isModalOpening }">
    <div
      class="zb-modal-backdrop"
      ref="backdrop"
      @click="handleBackdropClicked"
    ></div>

    <div class="zb-modal-box">
      <div class="zb-modal-content" :class="combinedContentClasses">
        <div class="zb-modal-title-container">
          <div class="zb-modal-title">
            <slot name="title" :modal="scopedSlots" />
          </div>

          <div
            class="zb-modal-close"
            :class="{ 'p-6': noPadding }"
            @click="hide"
            v-if="showCloseIcon"
          >
            <slot name="close">
              <svg width="24" height="24">
                <use xlink:href="/img/sprite.svg#ic_close"></use>
              </svg>
            </slot>
          </div>
        </div>

        <div class="zb-modal-scrollable-content">
          <slot :modal="scopedSlots" />
          <slot name="footer" />
        </div>

        <slot name="stickyFooter" :modal="scopedSlots" />
      </div>
    </div>
  </aside>
</template>

<script>
export default {
  props: {
    backdropDismiss: {
      type: Boolean,
      required: false,
      default: () => true,
    },
    noPadding: {
      type: Boolean,
      required: false,
      default: () => false,
    },
    showCloseIcon: {
      type: Boolean,
      required: false,
      default: () => true,
    },
    isFullScreen: {
      type: Boolean,
      required: false,
      default: () => false,
    },
    contentClass: {
      type: String,
      required: false,
      default: () => "",
    },
    proceedClosing: {
      type: Function,
      required: false,
      default: () => () => true,
    },
  },
  data() {
    return {
      isModalOpening: false,
    };
  },
  computed: {
    combinedContentClasses() {
      return {
        [this.contentClass]: true,
        "is-full-screen": this.isFullScreen,
        "p-6": !this.noPadding,
      };
    },
    scopedSlots() {
      return {
        show: this.show.bind(this),
        hide: this.hide.bind(this),
        isModalOpening: this.isModalOpening,
      };
    },
  },
  methods: {
    onEscape(k) {
      if (k.code === "Escape") {
        this.hide();
      }
    },
    show() {
      this.isModalOpening = true;
      this.$emit("open");
    },
    hide() {
      if (this.proceedClosing()) {
        this.isModalOpening = false;
        this.$emit("close");
      }
    },
    handleBackdropClicked() {
      if (this.backdropDismiss) {
        this.isModalOpening = false;

        this.$emit("close");
      }
    },
  },
  watch: {
    isModalOpening(value) {
      if (value) {
        document.body.classList.add("zb-fixed-body");
        toggleTrengoChat({ show: false });
        window.removeEventListener("keydown", this.onEscape);
        window.addEventListener("keydown", this.onEscape);

        setTimeout(() => {
          this.$refs.backdrop.classList.add("active");
        }, 400);
      } else {
        document.body.classList.remove("zb-fixed-body");
        toggleTrengoChat({ show: true });
        window.removeEventListener("keydown", this.onEscape);

        this.$refs.backdrop.classList.remove("active");
      }
    },
  },
};
</script>

<style scoped>
.zb-modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 5000;
  pointer-events: none;
  opacity: 0;
  transition: opacity 0.5s ease;
}

.zb-modal.active {
  opacity: 1;
  pointer-events: all;
}

.zb-modal-box {
  height: 100%;
}

.zb-modal-content {
  border-radius: 4px;
  background: white;
  width: 600px;
  margin: auto;
  top: 50%;
  transform: translateY(-50%);
  position: relative;
  display: flex;
  flex-direction: column;
  max-height: 90vh;
  box-shadow: 0px 2px 15px #0000006e;
  z-index: 1;
}

.zb-modal-content.is-full-screen {
  border-radius: 0;
  transform: none;
  top: 0;
  left: 0;
  right: 0;
  margin: 0;
  width: 100vw;
  height: 100%;
  max-height: 100vh;
  max-width: 100vw;
}

.zb-modal-backdrop {
  background-color: #00000075;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1;
}

.zb-modal-title-container {
  display: flex;
  flex: none;
}

.zb-modal-title {
  font-size: 24px;
  flex: 1;
}

.zb-modal-close {
  flex: none;
  cursor: pointer;
}

.zb-modal-scrollable-content {
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
}

.zb-modal-footer {
  margin-left: -24px;
  margin-right: -24px;
  padding-left: 24px;
  padding-right: 24px;
  border-top: 1px solid var(--black-light-2);
  padding-top: 24px;
}

@media screen and (min-width: 601px) and (max-width: 1200px) {
  .zb-modal-content {
    width: 80vw;
    max-width: 560px;
  }
}

@media screen and (max-width: 600px) {
  .zb-modal-content {
    width: 100% !important;
    max-height: 100vh;
    height: 100%;
    border-radius: 0px;
    box-shadow: none;
  }

  .zb-modal.slide-in-modal {
    opacity: 1;
    transition: transform 0.4s ease;
    transform: translateY(120%);
  }

  .zb-modal.slide-in-modal.active {
    transform: translateY(0);
  }

  .zb-modal.slide-in-modal .zb-modal-backdrop {
    opacity: 0;
    transition: opacity 0.2s ease;
  }

  .zb-modal.slide-in-modal .zb-modal-backdrop.active {
    opacity: 1;
    top: -64px;
  }
}
</style>
